import { Avatar, Base, Button, Flex, Icon, SkeletonBox, Text, TypeIconName } from '@bitrise/bitkit';
import { BitriseApp } from '@trace/types';
import React from 'react';
import dataAtIds from '../../dataAtIds.json';
import { BITRISE_APP_PROJECT_TYPE_ICON_MAP } from '../../constants/Apps';
import { trackEvent } from '../../utils/tracking';

const AppSwitcherListItem: React.FunctionComponent<BitriseApp> = (props) => {
  const { avatar_url: avatarUrl, project_type: projectType, slug, title } = props;
  const iconName: TypeIconName =
    (projectType && BITRISE_APP_PROJECT_TYPE_ICON_MAP[projectType]) || 'Support';

  const onOpenButtonClick = () => {
    trackEvent('AppSelector.GotoTrace', { appSlug: slug });
  };

  return (
    <Base
      borderColor="gray-1"
      borderRadius="x2"
      paddingHorizontal="x3"
      paddingVertical="x4"
      backgroundColor="gray-1"
    >
      <Flex direction="horizontal" gap="x2" alignChildrenVertical="middle">
        {title ? (
          <Avatar url={avatarUrl} name={title} size="3rem" borderRadius="x2" />
        ) : (
          <SkeletonBox height="3rem" width="3rem" />
        )}

        <Flex direction="vertical" grow>
          <Flex direction="horizontal" gap="x1">
            <Flex>
              <Icon name={iconName} title={projectType} />
            </Flex>

            <Flex grow>
              <Text config="7" weight="bold" Component="h5">
                {title || <SkeletonBox height="1rem" width="6rem" />}
              </Text>
            </Flex>
          </Flex>

          <Text config="8" textColor="gray-6">
            {title ? slug : <SkeletonBox height="1rem" width="10rem" />}
          </Text>
        </Flex>

        <Flex>
          {title ? (
            <Button
              Component="a"
              data-trace-at-id={dataAtIds.AppSwitcherOpenButton}
              type="button"
              size="small"
              level="primary"
              elevation="x1"
              href={`${process.env.BITRISE_APP_AUTH_URL}/app/${slug}/addon/addons-apm/login_page`}
              onClick={onOpenButtonClick}
            >
              Open in Trace
            </Button>
          ) : (
            <SkeletonBox height="2rem" width="6.875rem" />
          )}
        </Flex>
      </Flex>
    </Base>
  );
};

export default AppSwitcherListItem;
